import { Component } from '@angular/core';

@Component({
  selector: 'icon-edit',
  templateUrl: './icon-edit.component.html',
  styleUrls: ['./icon-edit.component.sass']
})
export class IconEditComponent {}
